import React from "react";
import Icon from "./Icon";
export default function Message(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M19.8 10.8C19.8035 12.1199 19.4951 13.4219 18.9 14.6C18.1945 16.0118 17.1098 17.1992 15.7675 18.0293C14.4252 18.8594 12.8783 19.2994 11.3 19.3C9.98018 19.3035 8.67816 18.9951 7.50005 18.4L1.80005 20.3L3.70005 14.6C3.10498 13.4219 2.79661 12.1199 2.80005 10.8C2.80066 9.22177 3.24066 7.67487 4.07077 6.33257C4.90088 4.99027 6.0883 3.90558 7.50005 3.20002C8.67816 2.60495 9.98018 2.29658 11.3 2.30002H11.8C13.8844 2.41501 15.8531 3.29478 17.3292 4.77088C18.8053 6.24697 19.6851 8.21567 19.8 10.3V10.8Z"
  }));
}
Message.displayname = "Message";
//# sourceMappingURL=Message.js.map